import axios from 'axios';

// One shared request per product type for the public fabric catalog (large payload).
const cache = new Map();

export const fetchVisibleCollections = (productType, { force = false } = {}) => {
  const key = productType || '';
  if (force || !cache.has(key)) {
    const p = axios.get(`${process.env.REACT_APP_BACKEND_URL}/api/fabric-collections/visible`, { params: productType ? { product_type: productType } : {} })
      .then(({ data }) => data || [])
      .catch((e) => { cache.delete(key); throw e; });
    cache.set(key, p);
  }
  return cache.get(key);
};
